//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseCreator.js";
import "../no/ObjectSelector.js";
import "../no/ObjectSelector.js";
let d=[[[0,"AcisVersion",1,0],[1,"ExportSelectionBlock",0,"ObjectSelector",0],[0,"FileSaveFlag",1,0],[0,"SettingsFile",1,0]],[[["filename"],"SaveSettings",{},1,0]],[]];
SPLM.AcisExporter = class extends SPLM.BaseCreator{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AcisExporter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AcisExporter.AcisVersionOption = Object.freeze({
    "V2024" : "V2024", "V2023" : "V2023", "V2022" : "V2022", "V2021" : "V2021", "V2020" : "V2020", "R29" : "R29", "R28" : "R28", "R27" : "R27", "R26" : "R26", "R25" : "R25", "R24" : "R24", "R23" : "R23", "R22" : "R22", "R21" : "R21", "R20" : "R20", "R19" : "R19", "R18" : "R18"});

export default SPLM;